<div class="card mb-5">
	<div class="card-header">
		<h3>Histórico de Facturas de Compra Pendientes por Recibir<a routerLink="/purchases/invoice" class="clickeable"
				style="text-decoration: none;">
				<span class="sp-con-default">
					<i class="fa-solid fa-circle-plus"></i>
					<i style="color: var(--bs-bg-servicios);" class="fa-solid fa-tag sp-el-default"></i>
				</span>
				<span>
					Nueva Factura de Compra
				</span>
			</a>
		</h3>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col" id="list-container">
				<h5>Filtrar</h5>
				<div class="row" id="options-date">
					<div class="col-sm form-group">
						<label for="type" class="form-label">Ver resultados de </label>
						<select name="type" id="type" (change)="changeType()" [(ngModel)]="type" class="form-select">
							<option value="0">Hoy</option>
							<option value="1">Últimos 7 días</option>
							<option value="2">Este mes</option>
							<option value="3">El mes pasado</option>
							<option value="4">Últimos dos meses</option>
							<option value="5">Últimos tres meses</option>
							<option value="6">Intervalo de fecha</option>
						</select>
					</div>
					<div class="col-sm form-group" *ngIf="type==6">
						<label for="startDate" class="form-label">Fecha Inicio</label>
						<input type="date" id="startDate" (change)="changeDate()" [(ngModel)]="startDate"
							name="startDate" class="form-control">
					</div>
					<div class="col-sm form-group" *ngIf="type==6">
						<label for="endDate" class="form-label">Ver resultados de </label>
						<input type="date" id="endDate" max="{{todayDate | date:'yyyy-MM-dd'}}" (change)="changeDate()"
							[(ngModel)]="endDate" name="endDate" class="form-control">
					</div>
				</div>
				<div class="row" style="margin-top: 1em;" id="options-other-filters">
					<div class="col-sm form-group">
						<label for="filterVendors" class="form-label">Buscar por número/serie/nit</label>
						<div class="input-group">
							<input type="text" id="filterVendors" [(ngModel)]="searchVendor"
								placeholder="Ingresa número o serie" name="filterVendors" class="form-control">
							<button class="btn btn-primary" (click)="searching()">
								<i class="fa fa-search"></i>
							</button>
						</div>
					</div>
					<div class="col-sm form-group">
						<label for="filterWarehouse" class="form-label">Bodega</label>
						<select name="filterWarehouse" (change)="filterCheck()" [(ngModel)]="warehouse"
							id="filterWarehouse" class="form-select">
							<option [ngValue]="null">Todas</option>
							<option *ngFor="let warehouse of warehouseList" [ngValue]="warehouse.id">
								{{warehouse.name}}
							</option>
						</select>
					</div>
					<div class="col-sm form-group">
						<label for="order" class="form-label">Orden </label>
						<select name="order" id="order" (change)="changeOrder()" [(ngModel)]="isAscendent"
							class="form-select">
							<option value="1">Ascendente</option>
							<option value="0">Descendente</option>
						</select>
						<span class="form-text">
							<i class="fa fa-circle-info"></i>
							<ng-container *ngIf="isAscendent==1">
								Los resultados se muestran de la fecha más lejana a la más reciente
							</ng-container>
							<ng-container *ngIf="isAscendent==0">
								Los resultados se muestran de la fecha más reciente a la más lejana
							</ng-container>
						</span>
					</div>
				</div>
				<div class="table-responsive" [class.table-responsive-without]="waitingFor" style="margin-bottom: 0;">
					<table class="table table-striped" style="margin-bottom: 0;">
						<thead>
							<tr>
								<th class="ta th-balance" [class.balance-success]="total>=0" colspan="9">Total
									{{total | currency:'Q'}}</th>
							</tr>
							<tr>
								<th class="ta">
									Serie
								</th>
								<th class="ta">
									Número
								</th>
								<th class="ta">
									Fecha Cert
								</th>
								<th class="ta">
									Bodega
								</th>
								<th class="ta">
									NIT
								</th>
								<th class="ta">
									Proveedor
								</th>
								<th class="ta">
									Total
								</th>
								<th class="ta">
									Acciones
								</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let invoice of pagination.filter">
								<tr [class.canceled-invoice]="invoice.cancelled"
									[class.hide-all]="waitingFor?.id==invoice.id">
									<td class="ta">
										{{invoice.series}}
									</td>
									<td class="ta">
										{{invoice.number}}
									</td>
									<td class="ta">
										{{convertToString(invoice.date)}}
									</td>
									<td class="ta">
										{{getWarehouseName(invoice.warehouse)}}
									</td>
									<td class="ta">
										<div *ngIf="invoice.providerData">
											{{invoice.providerData.nit}}
										</div>
									</td>
									<td class="ta limit-td">
										<div *ngIf="invoice.providerData">
											{{invoice.providerData.name}}
										</div>
									</td>
									<td class="ta">
										{{(invoice.totalCost + invoice.totalTaxes + invoice.extraTax) | currency :
										((invoice.currency==1)?"$":"Q")}}
									</td>
									<td class="ta">
										<div class="d-flex flex-row gap-1 justify-center">
											<span class="clickeable text-info" title="Recibir Orden"
												[appCheckPermission]="[5023]"
												[permissionType]="permissionType.UPDATE" *ngIf="!invoice.isNcre">
												<i class="fa-solid fa-receipt"></i>
												<!-- <span *ngIf="moving[invoice.id]"
													class="spinner-border spinner-border-sm" aria-hidden="true"></span> -->
											</span>
											<span title="Ver detalle"
												class="clickeable"
                                                (click)="showDetails(invoice);"
												[ngClass]="invoice['allAssociated']?'text-success':'text-warning'"
												[appCheckPermission]="[5023]" [permissionType]="permissionType.READ" *ngIf="!invoice.isNcre">
												<i  class="fa fa-eye"></i>
												<!-- <span 
													class="spinner-border spinner-border-sm" aria-hidden="true"></span> -->
											</span>
										</div>
									</td>
								</tr>
							</ng-container>
							<tr *ngIf="pagination.filter.length == 0">
								<td colspan="9" class="ta" style="color: gray">
									<i class="fa fa-circle-info"></i>No se encontraron documentos en las fechas
									seleccionadas
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<app-pagination-custom [elements]="pagination"></app-pagination-custom>
			</div>
		</div>
	</div>
</div>

<app-purchase-pending-receipt-details *ngIf="showModal"  [purchaseVId]="purchaseId" [purchaseV]="currentPurchase" [showModal]="showModal" (closed)="closeModal($event)"/>
